import { cfetch, BadStatusError, NoNetworkError } from '@confluence/network';

export const createRemoteLink = async ({
	cloudId,
	issueKey,
	url,
	title,
}: {
	cloudId: string;
	issueKey: string;
	url: string;
	title: string;
}): Promise<any> => {
	const body = {
		globalId: `confluence-page:${url}`,
		object: {
			url,
			title,
		},
	};

	try {
		const response = await cfetch(
			`/gateway/api/ex/jira/${cloudId}/rest/api/3/issue/${encodeURIComponent(issueKey)}/remotelink`,
			{
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				credentials: 'include',
				body: JSON.stringify(body),
			},
		);

		return response.json();
	} catch (err) {
		if (err instanceof NoNetworkError) {
			return null;
		}

		if (err instanceof BadStatusError && err.response.status === 404) {
			return null;
		}
		// TODO: add reporting when setting up dashboards
		return null;
	}
};
